export const tr = {
    'all-conditions-are-negative': 'Bir koşulda, tüm koşul dizileri için "Hiçbiri uygulanmadı" seçilemez.',
    'app-metrika-segment': 'AppMetrica segmenti',
    composition: 'kombine',
    'condition-rule-id-required': 'Hedef belirtilmedi',
    'condition-rule-period-required': 'Gün sayısı belirtilmedi',
    'condition-rule-period-value-interval': 'Doğru gün sayısını belirtin: {minValue} - {maxValue}',
    'condition-rule-period-value-max-value': 'Gün sayısı {value} değerini aşmamalıdır',
    'condition-rule-period-value-negative-value': 'Gün sayısı, negatif bir sayı olamaz',
    crm: 'CRM verileri',
    'description-max-length': 'Not, {value} karakteri aşmamalıdır',
    'description-must-contain-only-symbols':
        'Notta Türkçe, Rusça, Ukraynaca ve Kazakça harfler, Latin harfleri, rakamlar ve noktalama işaretleri kullanılabilir',
    email: 'e-posta',
    'geo-condition': 'coğrafi koşul',
    'geo-now': 'mevcut konum',
    'geo-regular': 'düzenli konum',
    'goals-or-segment-error': '{numberOfGroups} kural dizisinde hedefler/segmentler seçilmelidir',
    'inconsistent-name': 'Bu isimde bir koşul zaten var',
    'inconsistent-rules-groups': 'Bu kural dizisine sahip koşul zaten var',
    'incorrect-goal-id': 'Hatalı hedef belirtildi',
    'look-alike': 'benzer segment',
    mac: 'MAC adresleri',
    median: 'Mediana',
    'metrika-segment': 'Yandex.Metrica segmenti',
    'mobiles-ids': 'Mobil ID',
    'name-max-length': 'Koşul adı {value} karakteri aşmamalıdır',
    'name-must-contain-only-symbols':
        'Koşul adında Türkçe, Rusça, Ukraynaca, Kazakça harfler, Latin harfleri, rakamlar ve noktalama işaretleri kullanılabilir',
    'name-required': 'Koşul adı belirtilmedi',
    phones: 'telefonlar',
    pixel: 'piksel',
    'required-goal-id': 'Hedef belirtilmedi',
    'required-goal-period': 'Metrica segmentleri ve hedefleri olan kurallar için zaman aralığı belirtilmelidir',
    'rules-groups-cannot-be-null': 'Koşulda en az bir kural dizisi belirtilmelidir',
    'unknown-error': 'Yeniden pazarlama koşulu kaydedilemedi',
    'yandex-data': 'Yandex verileri'
};
